import { MODAL } from "../constants/index.js";

export default (elem) => elem && elem.matches(":" + MODAL);
